import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import { Tooltip } from '@mui/material';

export const TRANSCRIPT_ONLY_LABEL = 'Only transcript search is available for this library';

/**
 * The same fact in a few words, for surfaces that must render it as text rather than as this
 * glyph plus a tooltip — a tooltip is unreadable on touch, so anywhere the row is tappable on
 * mobile has to say it outright. Kept beside the long form so the two can't drift.
 */
export const TRANSCRIPT_ONLY_SHORT_LABEL = 'Transcript search only';

/**
 * Passive indicator (icon + tooltip) shown when a library skips visual indexing, so only
 * transcript search works. Used both as a corner overlay on the library card and inline next
 * to the library name in the in-library header — the caller supplies the styling via
 * `className` (icon size/color/positioning live there; this owns the icon, tooltip, and copy).
 */
export const TranscriptOnlyIndicator = ({ className }: { className?: string }) => (
  <Tooltip title={TRANSCRIPT_ONLY_LABEL} placement="bottom-start" arrow>
    <span className={className} aria-label={TRANSCRIPT_ONLY_LABEL}>
      <RecordVoiceOverIcon />
    </span>
  </Tooltip>
);
